import SalarieNumeroCongeSpec from '@/generated/controls/salarie/SalarieNumeroCongeSpec.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieNumeroCongeSpec
})
